import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Chip from "@mui/material/Chip";
import { LoopCircleLoading } from "react-loadingg";
import Avatar from "@mui/material/Avatar";

export default function EnemyDetail({ match }) {
  const idSearch = match.params.id;

  const [enemy, setEnemy] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(
        `https://revived-witch-api.herokuapp.com/api/enemies/${idSearch}`
      );
      res.json().then((res) => setEnemy(res.enemy));
    };

    fetchData();
  }, [idSearch]);
  return (
    <>
      {enemy.length === 0 || null ? (
        <LoopCircleLoading />
      ) : (
        <div style={{ marginTop: "30px" }}>
          <Grid>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Grid xs={12} md={6}>
                <Typography variant="h3">{enemy.name}</Typography>
              </Grid>

              <Grid xs={12} md={6}>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                >
                  <LocationOnIcon />
                  <Typography variant="h5">{enemy.location}</Typography>
                </Stack>
              </Grid>
            </Stack>
          </Grid>

          <Divider />
          <Typography style={{ marginTop: "30px" }}>
            {enemy.description}
          </Typography>
          <Grid container spacing={2} style={{ marginTop: "30px" }}>
            <Grid item xs={12} md={4} style={{ backgroundColor: "" }}>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={2}
              >
                <img
                  src={enemy.fullResImage}
                  alt="enemyImage"
                  style={{ margin: "auto", borderRadius: "20px" }}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={8} style={{ backgroundColor: "" }}>
              <Divider textAlign="left">Stats</Divider>

              <Stack
                direction="column"
                justifyContent="center"
                alignItems="flex-start"
                spacing={2}
                style={{ marginTop: "30px" }}
              >
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                >
                  <Avatar
                    style={{ width: 55, height: 45, borderRadius: "5px" }}
                    variant="square"
                    alt="rarityIcons"
                    src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637386231/RevivedWitch/healthIcons_g6dcnx.png"
                  />
                  <Chip
                    label=""
                    color="primary"
                    style={{
                      marginBottom: "20px",
                      minWidth: enemy.life + "px",
                      borderRadius: "5px",
                    }}
                  />
                </Stack>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                >
                  <Avatar
                    style={{ width: 55, height: 45, borderRadius: "5px" }}
                    variant="square"
                    alt="rarityIcons"
                    src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637386231/RevivedWitch/physicIcon_xfm7lh.png"
                  />
                  <Chip
                    label=""
                    color="primary"
                    style={{
                      marginBottom: "20px",
                      minWidth: enemy.physicalAttack + "px",
                      borderRadius: "5px",
                    }}
                  />
                </Stack>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                >
                  <Avatar
                    style={{ width: 55, height: 45, borderRadius: "5px" }}
                    variant="square"
                    alt="rarityIcons"
                    src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637386231/RevivedWitch/magicIcon_gvvlyn.png"
                  />
                  <Chip
                    label=""
                    color="primary"
                    style={{
                      marginBottom: "20px",
                      minWidth: enemy.magicAttack + "px",
                      borderRadius: "5px",
                    }}
                  />
                </Stack>
              </Stack>
              <Divider textAlign="left" style={{ marginTop: "10px" }}>
                Trait
              </Divider>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="flex-end"
                spacing={2}
              >
                <Chip
                  label={enemy.trait}
                  color="secondary"
                  style={{ marginTop: "20px", minWidth: "200px" }}
                />
              </Stack>
            </Grid>
            <Grid
              //container
              item
              xs={12}
              md={12}
              style={{ backgroundColor: "" }}
            >
              <Divider textAlign="center" style={{ marginBottom: "10px" }}>
                Enemy Skills
              </Divider>
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={3}
              >
                {enemy.skills.map((skill) => (
                  <>
                    <Stack
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                    >
                      <Chip
                        label={skill.name}
                        color="primary"
                        style={{ minWidth: "200px" }}
                      />
                    </Stack>
                    <Typography gutterBottom>{skill.description}</Typography>
                  </>
                ))}
              </Stack>
              <Divider style={{ marginBottom: 20, marginTop: 20 }} />
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
}
